import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { getNumberComma } from '../../utils/numberUtils';

const ProductInfo = ({ product }) => {
  return (
    <Box>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            제조사
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {product?.partnerNm}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            제품군
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" component="div">
            {product?.productLine}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            분류 코드
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" component="div">
            {product?.category}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            제품명
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {product?.productNm}
          </Typography>
        </Grid>
      </Grid>
      
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            제품 규격
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {product?.productSpec}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            매입가(매입처별)
          </Typography>
        </Grid>
        <Grid item xs={10}>
          {product?.purchasePrices?.length ? (
            product.purchasePrices.map((p) => (
              <Typography
                key={p.priceUuid || p.partnerUuid}
                variant="body2"
                component="div"
              >
                {p.partnerNm} : {getNumberComma(p.priceVal)}
              </Typography>
            ))
          ) : (
            <Typography variant="body2" component="div">
              {getNumberComma(product?.price)}
            </Typography>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            매출가
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" component="div">
            {getNumberComma(product?.priceConsume)}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            사용여부
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" component="div">
            {product?.useYn}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            단위
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography variant="body2" component="div">
            {product?.productUnit}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1 }}
      >
        <Grid item xs={2}>
          <Typography variant="subtitle2" component="div">
            사양
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Typography
            sx={{ whiteSpace: 'pre-line' }}
            variant="body2"
            component="div"
          >
            {product?.productDesc}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProductInfo;
